import styled from 'styled-components'

const Nav = styled.nav`
height: 100vh;
display: flex;
flex-direction: column;
justify-content: space-between;
overflow: hidden;
position: fixed;
`

export default Nav